import React, { useEffect, useState, useCallback } from 'react';
import { ImageService } from '../content/image-service';

// Single-image homepage banner slot backed by the CRM (ecom_images, same
// image_type='banner' as the hero carousel but a distinct page_key per slot).
// Falls back to a bundled static image until the CRM actually has one
// uploaded for that slot, so the section is never blank/broken.
const HomeBanner = ({ pageKey, fallbackSrc, alt, className }) => {
  const [src, setSrc] = useState(null);

  const fetchBanner = useCallback(async () => {
    try {
      const res = await ImageService.getAll({ image_type: 'banner', page_key: pageKey });
      const active = (res.data.data || []).filter((img) => img.is_active);
      if (active.length > 0) {
        setSrc(active[0].image_path);
      }
    } catch (err) {
      // Silently keep the fallback — a missing/failed CRM banner shouldn't
      // ever break the homepage.
    }
  }, [pageKey]);

  useEffect(() => {
    fetchBanner();
  }, [fetchBanner]);

  return (
    <img
      src={src || fallbackSrc}
      className={className}
      alt={alt}
      loading="lazy"
    />
  );
};

export default HomeBanner;
